<div
  *ngIf="unpaid.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
  <table
    mat-table
    [dataSource]="unpaid"
    class="sp-width__full">
    <ng-container matColumnDef="step_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <app-shared-id
          [content]="unpaid.step_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>
    <ng-container matColumnDef="store_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.STORE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ unpaid.store_name || '-' }} </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="company_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.COMPANY_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ unpaid.company_name || '-' }} </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="unpaid">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'UNPAID.UNPAID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ daysFromUnpaid(unpaid) > 30 ? 'SI' : 'NO' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="unpaid_from">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'UNPAID.UNPAID_FROM_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ (unpaid.created_at | date : 'short') || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="days_unpaid">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'UNPAID.DAYS_UNPAID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ daysFromUnpaid(unpaid) }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="attempts_counter">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'UNPAID.ATTEMPTS_COUNTER_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ unpaid.attempts_counter }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="index">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.INDEX_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ unpaid.step_index || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="qinetic">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">Qinetic ID</span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <app-shared-id
          *ngIf="unpaid.position_id"
          [content]="unpaid.position_id"
          [content_class]="'sp-color__green sp-text__bold'"
          [is_shrinked_id]="false"></app-shared-id>
        <span *ngIf="!unpaid.position_id && !unpaid.position_error"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'BUYERS.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          [content]="step.buyer_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer_fullname">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span
          *ngIf="unpaid.buyer_firstname"
          class="sp-text__ellipsized">
          <b>
            {{ getFullName(unpaid).length > 30 ? (getFullName(unpaid) | slice : 0 : 30) + '...' : getFullName(unpaid) }}
          </b>
        </span>

        <span *ngIf="!unpaid.buyer_firstname">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="step_created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ (unpaid.step_created_at | date : 'short') || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="due_date">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STEPS.DUE_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ (unpaid.due_date | date : 'short') || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <div
          [ngClass]="getStepStatusClass(step.status)"
          class="sp-order__status-radius sp-row__center sp-padding__horiz sp-width__fit-content">
          <span class="sp-text__ellipsized sp-text__center">{{
            getStepStatusLabel(step.status || '-') | translate | lowercase
          }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let step">
        <app-shared-id
          [content]="step.order_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'GENERAL.AMOUNT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-text__ellipsized">
          <b>{{ unpaid.amount / 100 || 0 | number : '0.2-2' }} {{ getCurrencyLabel(unpaid.order_currency) }}</b>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="recovered_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'UNPAID.UNPAID_RECOVERED_AT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <span class="sp-color__primary sp-text__ellipsized"> {{ (unpaid.recovered_at | date : 'short') || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let unpaid">
        <div class="sp-row__align sp-margin">
          <button
            matBadge="!"
            matBadgeSize="small"
            [matBadgeHidden]="!unpaid.note"
            (click)="onSetNoteClick(unpaid)"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent"
            [matTooltip]="'UNPAID.INSERT_NOTE_CTA' | translate">
            <mat-icon> description</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"></tr>
  </table>
</div>
